var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.448,
    height: 12.078,
    viewBox: "0 0 17.448 12.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M11.721,19.076a9.218,9.218,0,0,0,8.681-5.8.671.671,0,0,0,0-.47A9.218,9.218,0,0,0,11.721,7a9.218,9.218,0,0,0-8.681,5.8.671.671,0,0,0,0,.47A9.218,9.218,0,0,0,11.721,19.076Zm7.326-6.038a7.9,7.9,0,0,1-7.326,4.7,7.9,7.9,0,0,1-7.326-4.7,7.9,7.9,0,0,1,7.326-4.7A7.9,7.9,0,0,1,19.047,13.038Z",
    transform: "translate(-2.997 -6.999)",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 3.178,
    cy: 3.178,
    rx: 3.178,
    ry: 3.178,
    transform: "translate(5.546 2.687)",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.d42060dfc8a0249d47b648a38118610c.svg";
export { ForwardRef as ReactComponent };